import $ from 'jquery';

export default function navigation() {

  function banca() {
    $(document).on('click', '.topnav__item.topnav__item--banca .topnav__link', function() {
      //resetto il menu principale
      $('.navigation__item').removeClass('open');
      //resetto il menu ib
      $('.internet-banking').removeClass('open');
      
      if(!$(this).parents('.topnav__item--banca').hasClass('open')) {
        $(this).attr("aria-expanded", true);
        $(this).parents('.topnav__item--banca').addClass('open');
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parents('.topnav__item--banca').removeClass('open');
      }
    });
  }

  function nav() {
    $(document).on('click', '.navigation__link', function() {
      if(!$(this).parents('.navigation__item').hasClass('open')) {
        $(this).attr("aria-expanded", true);
        $('.navigation__item').removeClass('open');
        $(this).parents('.navigation__item').addClass('open');
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parents('.navigation__item').removeClass('open');
      }
    });
  }

  function internetBanking() {
    $(document).on('click', '.internet-banking__btn', function() {
      //resetto il menu principale
      $('.navigation__item').removeClass('open');

      if(!$(this).parents('.internet-banking').hasClass('open')) {
        $(this).attr("aria-expanded", true);
        $(this).parents('.internet-banking').addClass('open');
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parents('.internet-banking').removeClass('open');
      }
    });
  }

  function hamburger() {
    $('.hamburger').on('click', function() {
      //resetto il menu "internet-banking"
      $('.internet-banking').removeClass('open');
      //resetto il menu principale
      $('.navigation .navigation__item').removeClass('open');

      if(!$(this).hasClass('open')) {
        $(this).addClass('open');
        $('.topnav, .header').addClass('open');
      } else {
        $(this).removeClass('open');
        $('.topnav, .header').removeClass('open');
      }
    });
  }

  function submenu() {
    $('.submenu .submenu__btn').on('click', function() {
      if(!$(this).parents('.submenu').hasClass('open')) {
        $(this).parents('.submenu').addClass('open');
      } else {
        $(this).parents('.submenu').removeClass('open');
      }
    });
  }

  function footer() {
    $(document).on('click', '.footer__btn', function() {
      if(!$(this).parents('.footer__nav').hasClass('open')) {
        $(this).parents('.footer__nav').addClass('open');
      } else {
        $(this).parents('.footer__nav').removeClass('open');
      }
    });
  }
  
  $( document ).ready(function() {
    //bottone "La Banca"
    if($('.topnav__item.topnav__item--banca .topnav__link').length > 0) {
      banca();
    }
    //menu principale
    if($('.navigation .navigation__link').length > 0) {
      nav();
    }
    //bottone "Internet Banking"
    if($('.internet-banking .internet-banking__btn').length > 0) {
      internetBanking();
    }
    //Hamburger (smatphone)
    if($('.hamburger').length > 0) {
      hamburger();
    }
    //Submenu (smatphone)
    if($('.submenu .submenu__btn').length > 0) {
      submenu();
    }
    //Footer (smatphone)
    if($('.footer .footer__btn').length > 0) {
      footer();
    }
  });  
}




























